import { useNavigate } from '@tanstack/react-router';
import { Button, notify } from '@yembo/yemblocks-core';
import { isValidEmail } from '@yembo/yemblocks-core/dist/_util';
import { TextInput } from '@yembo/yemblocks-core/dist/TextInput';
import { Dispatch, SetStateAction, useState } from 'react';
import { putRequestPasswordReset } from 'src/queries/Login';
import { useSubmitOnEnterKey } from 'src/react/_hooks/useEnterKeySubmit';
import { LoginFormData } from '..';
import { SectionHeader } from '../SectionHeader';

type Props = {
  formData: LoginFormData;
  setFormData: Dispatch<SetStateAction<LoginFormData>>;
};

export const ForgotPassword = ({ formData, setFormData }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { email, isEmailValid } = formData;

  const navigate = useNavigate();

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      await putRequestPasswordReset(email ?? '');
      notify.success('If the email provided was on file, then a reset email has been sent.');
    } finally {
      setIsLoading(false);
    }
  };

  useSubmitOnEnterKey({ onSubmit });

  return (
    <div className='forgot-password authentication-form'>
      <SectionHeader
        heading='Reset Password'
        caption='Enter your email and we will send you a link to reset your password'
      />
      <div className='email-input-wrapper'>
        <TextInput
          name='email'
          inputMode='email'
          label='Email'
          value={email}
          onChange={({ currentTarget: { value } }) => {
            value = value.replaceAll(' ', '');
            setFormData((data) => ({
              ...data,
              email: value,
              isEmailValid: isValidEmail(value),
            }));
          }}
          checkValidity={() => (formData.isEmailValid ? undefined : 'Invalid email')}
        />
      </div>
      <div className='buttons-wrapper'>
        <Button text='Submit' onClick={onSubmit} isLoading={isLoading} isDisabled={!email || !isEmailValid} />
        <Button text='Back' kind='flat' onClick={() => navigate({ to: '..', replace: true })} isDisabled={isLoading} />
      </div>
    </div>
  );
};
